import { Phone, MapPin } from "lucide-react";
import logo from "@/assets/logo.webp";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src={logo} 
                alt="Smile Care Dental" 
                width={48}
                height={48}
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="opacity-70 text-sm">
              Gandhinagar's most trusted multispeciality dental clinic, 
              serving families with painless treatments and personalized care.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 opacity-70">
              <li>
                <a href="#services" className="hover:opacity-100 transition-opacity">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#why-us" className="hover:opacity-100 transition-opacity">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#testimonials" className="hover:opacity-100 transition-opacity">
                  Patient Stories
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:opacity-100 transition-opacity">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:opacity-100 transition-opacity">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 opacity-70">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 shrink-0 mt-0.5" />
                <span className="text-sm">
                  Pramukh Arcade 2, A-212, near Terracotta, Kudasan, 
                  Gandhinagar – 382421
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-5 h-5" />
                <a href="tel:+916353963147" className="hover:opacity-100 transition-opacity">
                  063539 63147
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/20 pt-8 text-center opacity-60 text-sm">
          <p>
            © {currentYear} Smile Care Dental. All rights reserved. | 
            Best Dental Clinic in Gandhinagar
          </p>
        </div>
      </div>
    </footer>
  );
};
